module.exports = __webpack_public_path__ + "media/images/icon_a7-3215e2a5e8e4e36582563027e272b530.png";